const styles = theme => ({
  paper: theme.mixins.gutters({
    boxShadow: 'none',
    marginBottom: 16,
    marginTop: 32,
    paddingBottom: 24,
    paddingTop: 24
  }),
  heading: {
    color: '#183f7d',
    fontSize: '1.15rem',
    fontWeight: 500
  },
  description: {
    color: '#63738a',
    fontSize: '0.9rem',
    lineHeight: 1.45,
    marginBottom: 22,
    marginTop: 6
  },
  formControl: {
    width: '100%'
  },
  questionGroup: {
    marginBottom: 8
  },
  questionLabel: {
    color: '#26384f',
    fontSize: '0.9rem',
    fontWeight: 500,
    lineHeight: 1.5,
    marginBottom: 7
  },
  checkboxList: {
    border: '1px solid #dbe2eb',
    display: 'grid',
    gridGap: '7px 12px',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    padding: '10px 12px'
  },
  checkboxControl: {
    marginLeft: 0,
    marginRight: 0,
    minHeight: 32,
    '& span:last-child': {
      color: '#405169',
      fontSize: '0.82rem',
      lineHeight: 1.25
    }
  },
  button: {
    marginTop: 24
  },
  saved: {
    color: theme.palette.success.main,
    fontSize: '0.88rem',
    marginTop: 18
  },
  error: {
    color: theme.palette.error.main,
    fontSize: '0.88rem',
    marginTop: 18
  },
  '@media (max-width: 600px)': {
    checkboxList: {
      gridTemplateColumns: '1fr'
    }
  }
})

export default styles
